module.exports = __webpack_public_path__ + "img/activeicon-network.14918f03.svg";